/**
 * Romanian Tax Engine - Investment Tax Calculator
 * Simplified version with only Savings Account and Unit Linked
 */

// Investment types
export const INVESTMENT_TYPES = {
  SAVINGS_ACCOUNT: 'savings_account',
  UNIT_LINKED: 'unit_linked',
};

// Tax rules for each investment type
export const TAX_RULES = {
  [INVESTMENT_TYPES.SAVINGS_ACCOUNT]: {
    interestTaxRate: 10,
    taxOnEachPeriod: true,
    useSimpleInterest: true, // Dobândă simplă
    hasAdminFee: false,
    description: {
      ro: 'Dobândă simplă, impozit 10% pe dobândă',
      en: 'Simple interest, 10% tax on interest',
    },
  },
  [INVESTMENT_TYPES.UNIT_LINKED]: {
    interestTaxRate: 0, // No annual tax during accumulation
    taxOnEachPeriod: false,
    useSimpleInterest: false, // Dobândă compusă
    hasAdminFee: true,
    defaultAdminFee: 1.5, // Default 1.5% annual admin fee
    description: {
      ro: 'Dobândă compusă, fără taxare anuală în acumulare',
      en: 'Compound interest, no annual tax during accumulation',
    },
    warning: {
      ro: 'Comisionul administrativ poate varia în funcție de contract',
      en: 'Administrative fee may vary depending on contract',
    },
  },
};

/**
 * Get tax configuration for investment type
 */
export const getTaxConfig = (investmentType) => {
  return TAX_RULES[investmentType] || TAX_RULES[INVESTMENT_TYPES.UNIT_LINKED];
};

/**
 * Get investment type labels
 */
export const getInvestmentTypeLabels = (language = 'ro') => {
  const labels = {
    [INVESTMENT_TYPES.SAVINGS_ACCOUNT]: {
      ro: 'Cont de economii',
      en: 'Savings Account',
    },
    [INVESTMENT_TYPES.UNIT_LINKED]: {
      ro: 'Unit Linked',
      en: 'Unit Linked',
    },
  };
  
  return Object.entries(labels).map(([value, label]) => ({
    value,
    label: label[language],
    description: TAX_RULES[value]?.description?.[language] || '',
    warning: TAX_RULES[value]?.warning?.[language] || null,
    hasAdminFee: TAX_RULES[value]?.hasAdminFee || false,
    useSimpleInterest: TAX_RULES[value]?.useSimpleInterest || false,
  }));
};
